import { Component, OnInit, Input, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { TelemedicineService } from '../../services/telemedicine.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
declare var document: any
import _moment from 'proxies/dayjs';

@Component({
    selector: 'app-telemedicine',
    templateUrl: './telemedicine.component.html',
    styleUrls: ['./telemedicine.component.scss'],
    standalone: false
})
export class TelemedicineComponent implements OnInit, OnDestroy {
  muteCss: boolean = false;
  unmuteVideo: boolean = false;
  showVideo: boolean = false;
  @Input() channelId: any;
  key: any;
  navbarBrandFull: any;
  friendName: any;
  enableJoin: boolean = true;
  localMedia: boolean = true;
  enableRejoin: boolean = false;
  localButton: boolean = true;
  showTextCss: boolean = false;
  enterRoom: boolean = false;
  hidelocalVideo: boolean = false;
  showLocalVideo: boolean = true;
  hidethreeDots: boolean = true;
  timer: number;  moment = _moment;
  showTimer: boolean = false;
  showMenus: boolean = true;
  firstCamera: boolean = true;
  mutedisable: boolean = false;
  muteCamera: boolean = false
  joinRoom: boolean = false;
  showCameraPopUp: boolean = false;
  device: any = "";
  resourceName: String = "Tele-consultation"
  audioOnly: boolean = false
  showAudioWaveform: boolean = false

  constructor(
    public teleService: TelemedicineService,
    public baseServices: BaseService,
    public appService: AppService,
    private alert: AlertsService,
    private loader: LoaderService,
    private auth: AuthenticationService,
    private route: Router,
    private aRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private ngZone: NgZone,
    private utilService?: UtilService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.teleService.init(() => {
      if (this.teleService.currentCall.action != undefined) {
        if (this.teleService.currentCall.action.datasource) {
          if (this.teleService.currentCall.action.datasource.condition) {
            var Arr = []
            for (let i = 0; i < Object.keys(this.teleService.currentCall.action.datasource.condition).length; i++) {
              if (this.teleService.currentCall.action.datasource.condition[Object.keys(this.teleService.currentCall.action.datasource.condition)[i]] == this.teleService.currentCall.emrKey[Object.keys(this.teleService.currentCall.action.datasource.condition)[i]]) {
                Arr.push(true)
              } else {
                Arr.push(false)
              }
              if (Arr.includes(true)) {
                // debugger;
                this.aftercheckstartCondition()
              } else {
                // debugger;
                this.enableJoin = false
              }
            }
          } else {
            this.aftercheckstartCondition()
            this.enableJoin = false
          }
        } else {
          // this.apiCalling()
          this.enableJoin = false
        }
      } else {
        this.enableJoin = false
      }
      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges()
      }
    })
    this.checkCameraAccessStatus("both", () => {

    })
  }

  checkCameraAccessStatus(device, callback) {
    var _that = this;
    this.ngZone.run(() => {
      if (this.appService.checkNativeApp() || this.utilService.isiOS()) {
        if (device == "microphone") {
          callback("unmute")
        } else {
          callback("onCamera");
        }
      } else if (navigator.permissions && navigator.permissions != undefined) {
        const permissionName = "microphone" as PermissionName;
        navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
          if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
            _that.muteCss = true;
            _that.mutedisable = true;
            if (device == "both" || device == "microphone") {
              _that.alert.error("Please give permission to access microphone");
              _that.showCameraPopUp = true;
              _that.device = "microphone";
              callback("mute")
            }
          } else {
            if (device == "both" || device == "microphone") {
              _that.mutedisable = false;
              callback("unmute")
            }
          }
        })
        const permissionNameC = "camera" as PermissionName;
        const priorityCode = this?.teleService?.currentCall?.priorityCode;
        if (priorityCode != undefined && priorityCode != "telephonic") {
          navigator.permissions.query({ name: permissionNameC }).then(function (permissionStatus) {
            if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
              _that.unmuteVideo = true;
              _that.muteCamera = true;
              if (device == "both" || device == "camera") {
                _that.alert.error("Please give permission to access Camera");
                _that.showCameraPopUp = true;
                _that.device = "camera";
                callback("offCamera")
              }
            } else {
              if (device == "both" || device == "camera") {
                _that.muteCamera = false;
                callback("onCamera");
              }
            }
          })
        }
      }
    })
  }

  checkJoin() {
    this.teleService.currentInstance.checkHadleRequest()
  }

  checksendPrescriptionCondition(cb) {
    if (this.teleService.currentCall && this.teleService.currentCall.action && this.teleService.currentCall.action.prescription && !this.teleService.currentCall.action.prescription.view_emr_condition) {
      cb(true);
      return;
    }
    this.baseServices.get(this.teleService.currentCall.action.prescription.view_emr_condition.query_id, this.changeArgs(this.teleService.currentCall.action.prescription.view_emr_condition.args, this.teleService.currentCall.emrKey), this.teleService.currentCall.action.prescription.view_emr_condition.resource, this.teleService.currentCall.action.prescription.view_emr_condition.application).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.ngZone.run(() => {
            this.alert.error(data.message);
          })
          cb(false);
        } else {
          cb(true);
        }
      })
  }

  aftercheckstartCondition() {
    if (this.teleService.currentCall.action.datasource.data != undefined) {
      var res = this.teleService.currentCall.action.datasource.data[0];
      for (let i = 0; i < Object.keys(res).length; i++) {
        this.teleService.currentCall.emrKey[Object.keys(res)[i]] = res[Object.keys(res)[i]];
      }
      this.apiCalling()
    } else {
      this.apiCalling()
    }
  }

  apiCalling() {
    this.baseServices.action(this.teleService.currentCall.emrKey, this.teleService.currentCall.action.datasource.action, this.teleService.currentCall.action.datasource.application, this.teleService.currentCall.action.datasource.resource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.ngZone.run(() => {
            this.alert.error(data.message);
            this.teleService.closeCall();
            this.teleService.setMessage(false);
          })
        } else {
          this.enableJoin = false;
        }
        if (this.teleService.currentCall.callbackApiInit != undefined) {
          this.teleService.currentCall.callbackApiInit();
        }
      })
  }

  ngOnDestroy() {
    this.ngZone.run(() => {
      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges()
      }
    })
  }

  joinCall() {
    this.joinRoom = true;
    this.loader.showSpinner()
    this.teleService.init(() => {
      this.baseServices.get("GET_CREDENTIALS_TELEMEDICINE", "", "third_party_app_credentials", "system-management").subscribe((res) => {
        this.localMedia = false;
        this.localButton = false;
        this.hidethreeDots = false
        if (this.teleService.currentCall.action != undefined && this.teleService?.currentCall?.emrKey?.priorityCode != 'telephonic') {
          console.log("this.teleService.currentCall.channelId ;; ", this.teleService.currentCall.channelId, "");
          this.key = this.teleService.currentCall.data
          this.getstartCall(res.resource[0].value, this.teleService.currentCall.channelId)
          // In Case on Audio Call
        } else if (this.teleService.currentCall.action != undefined && this.teleService?.currentCall?.emrKey?.priorityCode === 'telephonic') {
          console.log("this.teleService.currentCall.channelId ;; ", this.teleService.currentCall.channelId, "");
          this.key = this.teleService.currentCall.data
          this.unmuteVideo = true
          this.audioOnly = true; // Set audio-only mode
          this.startAudioCall(res.resource[0].value, this.teleService.currentCall.channelId)
        } else {
          console.log("this.teleService.currentCall.channelId ;; ", this.teleService.currentCall.channelId, "");
          this.key = this.teleService.currentCall.data
          this.getstartCall(res.resource[0].value, this.teleService.currentCall.channelId)
        }
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        // if(this.auth.getUserType().toLowerCase() == 'patient') {
        //   this.alert.info("Please wait for the doctor to join the call")
        // }
      })
    })
  }
  startAudioCall(res, hasChannelValue) {
    this.ngZone.run(() => {
      this.teleService.currentInstance.joinchannel(res, hasChannelValue, true, true, true);
      this.enterRoom = true;
      this.showTextCss = true;
      this.hidelocalVideo = true
      this.unmuteVideo = true
      this.loader.hideSpinner();
      setTimeout(() => {
        // 🔴 Force disable video streams
        if (document.getElementById("networkSpeed").innerText != '') {
          this.showAudioWaveform = true;
          this.showLocalVideo = false
        }
      }, 2000);
      if (this.audioOnly) {
        // 🔴 Force disable video streams
        this.teleService.currentInstance.muteLocalVideoStream(true);
      }

      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges();
      }
    });
  }

  getstartCall(res, hasChannelValue) {
    this.ngZone.run(() => {
      this.teleService.currentInstance.joinchannel(res, hasChannelValue, this.muteCss, this.unmuteVideo);
      this.enterRoom = true;
      this.showTextCss = true;
      this.loader.hideSpinner()
      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges()
      }
    })
  }

  checkEnterRoom() {
    this.ngZone.run(() => {
      return this.enterRoom
    })
  }

  joinChannel(channelId: any) {
    console.log("inside join channel", channelId)
  }

  changeMuteStatus() {
    this.ngZone.run(() => {
      this.checkCameraAccessStatus("microphone", (value) => {
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        if (value == "mute") {
          return false
        } else {
          this.muteCss = !this.muteCss
          if (this.muteCss)
            this.alert.info("Microphone is turned off.")
          else
            this.alert.info("Microphone is turned on.")
          return this.muteCss
        }
      })
    })
  }

  changeAgoraMuteStatus() {
    this.ngZone.run(() => {
      this.checkCameraAccessStatus("microphone", (value) => {
        if (!this.cdRef?.['destroyed']) {
          this.cdRef.detectChanges();
        }
  
        if (value === "mute") return false;
  
        this.muteCss = !this.muteCss;
        const micStatus = this.muteCss ? "Microphone is turned off." : "Microphone is turned on.";
  
        if (this.audioOnly) {
          this.muteCss
            ? this.teleService.currentInstance.forceMuteAudio()
            : this.teleService.currentInstance.forceUnmuteAudio();
        }
  
        this.alert.info(`${micStatus}`);
        return this.muteCss;
      });
    });
  }

  

  changeCameraStatus() {
    if (!this.audioOnly) {
      this.ngZone.run(() => {

        this.checkCameraAccessStatus("camera", (value) => {
          if (!this.cdRef['destroyed']) {
            this.cdRef.detectChanges();
          }
          if (value == "offCamera") {
            return false
          } else {
            return this.unmuteVideo = !this.unmuteVideo
          }
        })
      })
    } else {
      this.alert.info("This Features is Not Active")
      return
    }

  }

  changeAgoraCameraStatus() {
    this.ngZone.run(() => {
      this.checkCameraAccessStatus("camera", (value) => {
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        if (value == "offCamera") {
          return false
        } else {
          return this.unmuteVideo = !this.unmuteVideo
        }
      })

    })
  }


  leavechannel(hasChannelValue: any, data: any) {
    document.getElementsByClassName("additional_text")[0].innerText = "";
    if (document.getElementById("connectingText"))
      document.getElementById("connectingText").innerText = "";
    if (document.getElementById("networkSpeed"))
      document.getElementById("networkSpeed").innerText = "";
    if (document.getElementById("duration"))
      document.getElementById("duration").innerText = "";
    this.joinRoom = false;
    if (this.enterRoom) {
      if (!data) {
        this.startTimer()
        this.enableRejoin = true;
        this.showAudioWaveform = false
        this.localButton = true;
        this.hidethreeDots = true;
        this.teleService.currentInstance.leavechannel();
        // this.showTextCss = false;
      } else {
        this.hidethreeDots = true
        this.teleService.closeCall();
        this.teleService.setMessage(false);
        this.teleService.currentInstance.leavechannel();
      }
    } else {
      this.teleService.closeCall();
      this.teleService.setMessage(false);
    }
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges()
    }
  }

  startTimer() {
    const that = this
    that.timer = 5;
    that.showTimer = true;
    let timerInterval = setTimeout(() => {
      that.timer -= 1;
      if (that.timer <= 0) {
        clearInterval(timerInterval);
        that.showTimer = false;
      }
    }, 1000)
  }


  viewEmr(d: any, s: any) {
    if (d.hasOwnProperty("prescription")) {
      var q = {}
      for (let i = 0; i < Object.keys(d.prescription.params).length; i++) {
        if (typeof (d.prescription.params[Object.keys(d.prescription.params)[i]]) != "object") {
          if (d.prescription.params[Object.keys(d.prescription.params)[i]].replace(/\s+/g, ' ').trim().split("")[0] == "'") {
            q[Object.keys(d.prescription.params)[i]] = d.prescription.params[Object.keys(d.prescription.params)[i]].replace(/\s+/g, ' ').trim().split("'")[1]
          } else {
            q[Object.keys(d.prescription.params)[i]] = s[d.prescription.params[Object.keys(d.prescription.params)[i]]]
          }
        } else {
          q[Object.keys(d.prescription.params)[i]] = JSON.stringify(d.prescription.params[Object.keys(d.prescription.params)[i]])
        }
        q["returnUrl"] = location.pathname;
      }
      this.ngZone.run(() => {
        this.route.navigate([d.prescription.view_emr], { queryParams: q })
      })

    } else {
      this.ngZone.run(() => {
        this.route.navigate([d.prescription.view_emr])
      })
    }
  }

  showRole() {
    return this.auth.getUserType().toLowerCase()
  }

  checkEmr(data) {
    if (data)
      return data.hasOwnProperty('prescription')
  }

  checkConsulat() {
    if (this.checkEmr(this.teleService.currentCall.action) && this.checkNotification(this.teleService.currentCall.action)) {
      return { "left": "128px" }
    } else if (this.checkEmr(this.teleService.currentCall.action)) {
      return ""
    } else {
      return { "left": "-115px" }
    }
  }

  switchCamera() {
    this.ngZone.run(() => {

      this.checkCameraAccessStatus("camera", (value) => {
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        if (value == "offCamera") {
          return false
        } else {
          this.teleService.currentInstance.switchCamera(this.firstCamera)
          return this.firstCamera = !this.firstCamera
        }
      })

    })
  }

  rejoin() {
    this.enableRejoin = false;
    this.localButton = false;
    this.joinCall();
  }

  endConsualatation() {
    this.ngZone.run(() => {
      this.baseServices.action(this.teleService.currentCall.emrKey, this.teleService.currentCall.action.detail_datasource.action, this.teleService.currentCall.action.detail_datasource.application, this.teleService.currentCall.action.detail_datasource.resource).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alert.error(data.message);
          } else {
            if (this.teleService.currentCall.callbackApiInit != undefined) {
              this.teleService.currentCall.callbackApiInit();
            }
            this.teleService.closeCall();
            this.teleService.setMessage(false);
          }
        })
    })
  }

  hideCamera() {
    // this.showMenus = true;
    this.ngZone.run(() => {

      this.checkCameraAccessStatus("camera", (value) => {
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        if (value == "offCamera") {
          return false
        } else {
          if (this.showLocalVideo)
            document.getElementById("local-player").style.display = "none"
          else {
            document.getElementById("local-player").style.display = "block"
          }
          return this.showLocalVideo = !this.showLocalVideo
        }
      })

    })
  }

  showHide() {
    // if (!this.cdRef['destroyed']) {
    //   this.cdRef.detectChanges()
    // }
    this.ngZone.run(() => {
      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges()
      }
      return this.showMenus = !this.showMenus
    })
  }

  checkNotification(data: any) {
    // this.ngZone.run(() => {
    //   if (!this.cdRef['destroyed']) {
    //     this.cdRef.detectChanges()
    //   }
    if (data) {
      return data.hasOwnProperty('send_notification');
    }
    // })
  }

  sendNotification(data: any) {
    if (!this.cdRef['destroyed']) {
      this.cdRef.detectChanges()
    }
    if(this.auth.getUserType().toLowerCase() == 'patient' && this.moment(this.teleService.currentCall.emrKey.serviceStartTime).diff(this.moment(), 'minutes') >= -1) {
      this.alert.info("The consultation has not started yet. Please wait until the scheduled appointment time.");
      return;
    }
    this.baseServices.get(data.query_id, this.changeArgs(data.args, this.teleService.currentCall.emrKey), data.resource, data.application).subscribe((res: any) => {
      if (res.errCode == 0) {
        this.alert.info("Notification sent")
      } else {
        this.alert.error(res.message)
      }
    })
  }

  closedevicePopup(event: any) {
    this.ngZone.run(() => {
      if (!this.cdRef['destroyed']) {
        this.cdRef.detectChanges()
      }
      this.showCameraPopUp = false;
    })
  }

  // getNotification$(resource: any) {
  //   // action(_resource, action, application?, resource?, bpmn_action?) 
  //   return this.baseServices.action(resource, this.teleService.currentCall.action.send_notification.action, this.teleService.currentCall.action.send_notification.application, this.teleService.currentCall.action.send_notification.resource)
  // }

  getOrderDetails() {
    this.checksendPrescriptionCondition((res) => {
      if (res) {
        if (!this.cdRef['destroyed']) {
          this.cdRef.detectChanges()
        }
        if (this.teleService.currentCall.action.prescription.datasource != undefined) {
          this.baseServices.get(this.teleService.currentCall.action.prescription.datasource.query_id, this.changeArgs(this.teleService.currentCall.action.prescription.datasource.args, this.teleService.currentCall.emrKey), this.teleService.currentCall.action.prescription.datasource.resource, this.teleService.currentCall.action.prescription.datasource.application).subscribe((res: any) => {
            if (this.teleService.currentCall.action.prescription.datasource.condition.stage == res.resource[0].stage) {
              this.viewEmr(this.teleService.currentCall.action.prescription.datasource, this.teleService.currentCall.emrKey)
            } else {
              this.viewEmr(this.teleService.currentCall.action, this.teleService.currentCall.emrKey)
            }
          })
        } else {
          this.viewEmr(this.teleService.currentCall.action, this.teleService.currentCall.emrKey)
        }
      } else {
        this.leavechannel(this.key, true)
      }
    })

  }

  changeArgs(args: any, data: any) {
    let str = args;
    let result = str.match(/\!!!(.*?)\!!!/gm);
    for (let i = 0; i < result.length; i++) {
      str = str.replace(result[i], data[result[i].replace(/!!!/g, "")])
    }
    return str;
  }

  isMobile() {
    // return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return this.utilService.isMobile()
  }

}